/*
 * @Copyright: 网易集成平台
 * @Author: xiaowenwen
 * @Date: 2022-03-22 09:17:11
 * @LastEditTime: 2022-03-29 09:41:42
 * @Description:
 */
/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/sync/ldap/${action[0]}`;

export default class LDAP {
  static CONTAINER_LIST(params) {
    return http.get(url`containerlist`, { params });
  }
  static ENTRY_LIST(params) {
    return http.get(url`entrylist`, { params });
  }
  static ENTRY_UserLIST(params) {
    return http.get(url`entryuserlist`, { params });
  }
  static ExportENTRY_UserLIST(params) {
    return http.get(url`exportentryuserlist`, { params });
  }
  static GET_PAGE(params) {
    return http.get(url`getpage`, { params });
  }
  static GET_SYNC(data) {
    return http.post(url`getsync`, data, formConfig);
  }
  static ENTRY_EDIT_DATA(params) {
    return http.get(url`entryeditdata`, { params });
  }
  static ENTRY_ADD_DATA(params) {
    return http.get(url`entryadddata`, { params });
  }
  static ENTRY_EDIT(data) {
    return http.post(url`entryedit`, data, formConfig);
  }
  static ENTRY_ADD(data) {
    return http.post(url`entryadd`, data, formConfig);
  }
  static ENTRY_ALONE(params) {
    return http.get(url`entryalone`, { params });
  }
  static ENTRY_REMOVE(data) {
    return http.post(url`entryremove`, data, formConfig);
  }
  static ENTRY_MOVE(data) {
    return http.post(url`entrymove`, data, formConfig);
  }
  static REMOVE_TASK_MAP_ALL(data) {
    return http.post(url`removetaskmapall`, data, formConfig);
  }
  static REMOVE_TASK_MAP_BAD(data) {
    return http.post(url`removetaskmapbad`, data, formConfig);
  }
  static UNIT_SEARCH(params) {
    return http.get(url`unitsearch`, { params });
  }
  static DELETE_CACHE() {
    return http.get(url`deletecache`, {});
  }
}
